export default "__VITE_ASSET__6fa175ee__"